export default {
  data () {
    return {
      scalseNum: 1,
      pagesHeight: 'auto',
      isMobile: false,
      IsAndroid: false,
      IsTV: false,
      IsFull: false
    }
  },
  computed: {},
  methods: {
    resize_window () {
      const width = document.documentElement.clientWidth
      const scalseNum = Number((width > 1920 ? 1920 : width) / 1920)
      this.scalseNum = scalseNum
      const route = this.$route
      this.pagesHeight = this.bodyHeight || (1080 * scalseNum)
      // if (this.isMobile) {
      //   document.getElementsByTagName('html')[0].style.fontSize = 100 * scalseNum + 'px'
      // } else {
      //   document.getElementsByTagName('html')[0].style.fontSize = '20px'
      // }
      document.getElementsByTagName('html')[0].style.fontSize = '20px'
      this.$nextTick(() => {
        console.log(document.body.requestFullscreen)
      })
    },
    browserRedirect () {
      var sUserAgent = navigator.userAgent.toLowerCase()
      var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
      var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
      var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
      var bIsAndroid = sUserAgent.match(/android/i) == 'android'
      var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
      var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
      var bIsTV = sUserAgent.match(/coocaa/i) == 'coocaa'
      // mozilla/5.0 (linux; android 6.0; 5s07_a2 build/mra58k; wv) applewebkit/537.36 (khtml, like gecko) version/4.0 chrome/89.0.4389.72 mqqbrowser/6.2 tbs/046140 mobile safari/537.36
      // mozilla/5.0 (windows nt 10.0; win64; x64) applewebkit/537.36 (khtml, like gecko) chrome/100.0.4896.88 safari/537.36
      console.log(sUserAgent, 'sUserAgent')
      this.IsAndroid = bIsAndroid
      this.IsTV = bIsTV
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        // setTimeout(() => { this.setFull() }, 1000)
        if (bIsTV) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    setFull () {
      let element = document.documentElement
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.msRequestFullscreen) { // 兼容ie
        element.msRequestFullscreen()
      } else if (element.mozRequestFullScreen) { // 兼容火狐
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) { // 兼容chrome和safari
        element.webkitRequestFullscreen()
      }
      this.resize_window()
      screen.orientation.lock('landscape-primary')
        .then(function () {
          console.log('landscape-primary')
        })
        .catch(function (error) {
          console.log(error)
        })
      this.IsFull = true
    },
    cancelFull () {
      console.log(22)
      // console.log('cancel')
      // screen.orientation.lock('natural')
      // let element = document.documentElement
      // if (element.exitFullScreen) {
      //   element.exitFullScreen()
      // } else if (element.mozCancelFullScreen) { // 兼容火狐
      //   element.mozCancelFullScreen()
      // } else if (element.webkitCancelFullScreen) { // 兼容chrome和safari
      //   element.webkitCancelFullScreen()
      // }
      let el = document
      let cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.mozCancelFullScreen || el.exitFullScreen || el.msExitFullscreen
      if (typeof cfs !== 'undefined' && cfs) {
        cfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        let wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{Esc}')
        }
      }

      this.IsFull = false
    }
  },
  mounted () {
    this.isMobile = this.browserRedirect()
    this.resize_window()
    window.addEventListener('resize', () => {
      this.resize_window()
    })
  },
  created () {}
}
